module.exports = __webpack_public_path__ + "img/logo-url-builder.5d1a0145.webp";